import { MsalAuthProvider, LoginType } from 'react-aad-msal'
import { Logger, LogLevel } from 'msal'

// The auth provider should be a singleton. Best practice is to only have it ever instantiated once.
// Avoid creating an instance inside the component it will be recreated on each render.
// If two providers are created on the same page it will cause authentication errors.
export const authProvider = new MsalAuthProvider(
  {
    auth: {
      authority: 'https://login.microsoftonline.com/ositau.onmicrosoft.com',
      clientId: '16af2a44-dbad-4ec1-9295-1415aac34763',
      postLogoutRedirectUri: window.location.origin,
      redirectUri: window.location.origin,
      validateAuthority: true,

      // After being redirected to the "redirectUri" page, should user
      // be redirected back to the Url where their login originated from?
      navigateToLoginRequestUrl: false,
    },
    // Enable logging of MSAL events for easier troubleshooting.
    // This should be disabled in production builds.
    system: {
      logger: new Logger((logLevel, message, containsPii) => {}, {
        level: LogLevel.Error,
        piiLoggingEnabled: true,
      }),
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
    },
  },
  {
    scopes: ['User.Read', 'api://16af2a44-dbad-4ec1-9295-1415aac34763/access_as_user'],
  },
  {
    loginType: LoginType.Popup,
    // When a token is refreshed it will be done by loading a page in an iframe.
    // Rather than reloading the same page, we can point to an empty html file which will prevent
    // site resources from being loaded twice.
    tokenRefreshUri: window.location.origin + '/auth.html',
  }
)

if (process.env.NODE_ENV === 'development') {
  const setRealAccountInfo = authProvider.setAccountInfo
  // Every accountInfo the AzureAD components receive is built here, so the idToken roles they read come from this.
  authProvider.setAccountInfo = (response) =>
    setRealAccountInfo(
      !response.account
        ? response
        : {
            ...response,
            account: {
              ...response.account,
              idToken: {
                ...response.account.idToken,
                roles: ['Admin', 'Sales', 'ITManager', 'SSE', 'OSITASS', 'CspAdmin'],
              },
            },
          }
    )
}
